import {NavigateFunction, NavigateOptions, To} from 'react-router-dom'

export function getDeferredNavigate(navigate: NavigateFunction) : NavigateFunction {
    return (arg1: To | number, arg2?: NavigateOptions): void => {
        if (typeof arg1 === 'number') {
            setTimeout(() => navigate(arg1))
        } else {
            setTimeout(() => navigate(arg1, arg2))
        }
    }
}
